import {
  updateSubscriptions,
  getStorageProfile,
} from '../../Data/SubscriptionCenterDataSource.js'
import {
  ACTIVE,
  INACTIVE,
  SERVICE_LABEL_USER,
  SERVICE_LABEL_ADVISOR,
  SERVICE_LABEL_INVESTOR,
} from '../../Landing/Helper/constants.js'

export async function updateFundSubscriptionBySubscriptionId(
  subscriptionProfile,
  id,
  selected
) {
  const storageProfile = getStorageProfile()
  const subscription = {
    wholeSalerID: null,
    contactID: subscriptionProfile?.value?.contactID,
    publicationID: id,
    status: selected ? ACTIVE : INACTIVE,
    actor:
      subscriptionProfile?.value?.role === SERVICE_LABEL_ADVISOR
        ? SERVICE_LABEL_USER
        : SERVICE_LABEL_INVESTOR,
    updatedTimeStamp: new Date().toISOString(),
    firstName:
      subscriptionProfile?.value?.firstName ?? storageProfile?.firstName,
    lastName: subscriptionProfile?.value?.lastName ?? storageProfile?.lastName,
    userId: subscriptionProfile?.value?.emailId ?? storageProfile?.emailId,
  }
  await updateSubscriptions({
    subscriptions: [subscription],
  })
}
